export const TitleSx = { fontSize: '12px', fontWeight: '500' };
export const ContentSx = { fontSize: '16px' };
export const TitleIconSx = { position: 'relative', top: '2px' };
